import React, { Component } from 'react';
import styles from './footer.module.scss';

class Footer extends Component {
  render() {
    return (
      <footer className={styles.footer}>
        <img
            src="/img-multiple/img/pins/multiple-pin.svg"
            alt="Icon for multiple locations"
            width={24}
            className={styles.legendImage}
        />
        <span className={styles.legend}>Projects in multiple locations and/or multiple LGAs.</span>
        <span className={styles.warning}>
          Project locations are indicative of general area only.
        </span>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/footer.js